"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonCustodialThirdPartyCondition = exports.nonCustodialFirstPartyCondition = void 0;
const ConditionField_1 = __importDefault(require("./ConditionField"));
const ThresholdCondition_1 = __importDefault(require("./ThresholdCondition"));
exports.nonCustodialFirstPartyCondition = new ThresholdCondition_1.default([
    new ConditionField_1.default('originatorAccountNumber'),
    new ConditionField_1.default('originatorOwnershipProof'),
    new ConditionField_1.default('beneficiaryAccountNumber'),
    new ConditionField_1.default('beneficiaryOwnershipProof'),
], 'AND');
exports.nonCustodialThirdPartyCondition = new ThresholdCondition_1.default([
    new ConditionField_1.default('originatorAccountNumber'),
    new ConditionField_1.default('originatorName'),
    new ConditionField_1.default('beneficiaryAccountNumber'),
    new ConditionField_1.default('beneficiaryName'),
], 'AND');
